<template>
  <section class="results">
    <div class="container">
      <p class="info">Want terwijl jij deze special hebt gelezen:</p>
      <div
        class="row"
        v-if="results"
      >
        <ResultItem
          class="item"
          v-for="(result, index) in results"
          :key="index"
          v-bind="result"
        />
      </div>
    </div>
  </section>
</template>

<script>
import ResultItem from '@/components/result-item'
import { chapterMixin } from '@/mixins'
import { BusIcon, BoxIcon, MoneyIcon, ReturnIcon } from '@/components/icons'

export default {
  name: 'Results',
  data () {
    return {
      counter: 0,
      results: [{
        amount: 0,
        icon: BoxIcon,
        description: 'pakketjes verstuurd'
      }, {
        icon: BusIcon,
        amount: 0,
        description: 'busjes uitgerukt'
      }, {
        amount: 0,
        icon: MoneyIcon,
        description: 'verdiende een bezorger zoveel'
      }, {
        amount: 266,
        icon: ReturnIcon,
        description: 'pakketjes retour gestuurd'
      }]
    }
  },
  mixins: [chapterMixin],
  components: {
    ResultItem
  },
  mounted () {
    setInterval(this.increaseCounter, 3000)
  },
  methods: {
    increaseCounter () {
      this.counter += 3
    }
  },
  watch: {
    counter () {
      this.results[0].amount = Math.ceil(this.counter * 12.15)
      this.results[1].amount = Math.ceil(this.counter * 0.09)
      const costs = '' + (this.counter * 0.0029).toFixed(2)
      this.results[2].amount = `${costs.replace('.', ',')}`
      this.results[3].amount = Math.ceil(this.counter * 1.8)
    }
  }
}
</script>

<style lang="scss" scoped>
.results {
  padding-top: 6em;
  padding-bottom: 6em;
}

.info {
  margin: 0 auto 1em;
  text-align: center;
}

.item {
  @media (min-width: 767px) {
    width: 50%;
    float: left;

    &:nth-child(2n+3) {
      clear: both;
    }
  }
}
</style>
